// src/utils/notifications/deepLink.ts
import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";

export type FocusTarget =
  | { kind: "comment"; id: number }
  | { kind: "post"; id: number }
  | { kind: "reaction"; id: number };

export function parseFocusParam(v?: string | null): FocusTarget | undefined {
  if (!v) return;

  // support: comment-12 OR comment:12
  let kind: string | undefined;
  let raw: string | undefined;

  if (v.includes(":")) {
    [kind, raw] = v.split(":");
  } else if (v.includes("-")) {
    [kind, raw] = v.split("-");
  }

  const id = Number(raw);
  if (!Number.isFinite(id)) return;

  if (kind === "comment") return { kind: "comment", id };
  if (kind === "post") return { kind: "post", id };
  if (kind === "reaction") return { kind: "reaction", id };
}


// --- NEW: special routes for notification targets ---
function normalizeNotificationUrl(link: string): string {
  // Keep absolute/relative URLs
  if (/^https?:\/\//i.test(link) || link.startsWith("/")) return link;

  // Friendship notifications
  if (link === "friendships" || link.startsWith("friendship"))
    return "/settings/friendships?tab=requests";

  // Fellowship notifications
  if (link === "fellowship" || link.startsWith("fellowship"))
    return "/settings/lit-covenant";

  // Default: normalize relative path
  return `/${link.replace(/^\/+/, "")}`;
}

export async function openNotificationLink(
  router: AppRouterInstance,
  link: string,
  markRead?: () => Promise<void>
) {
  try {
    if (markRead) await markRead();
  } catch {
    /* ignore errors */
  }
  router.push(normalizeNotificationUrl(link));
}

export { normalizeNotificationUrl };
